"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_public__sector(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "03f076b9-d3a4-49a8-a3f2-45d68955c550",
    x1: 3878.34,
    y1: 11964.48,
    x2: 3969.11,
    y2: 12055.25,
    gradientTransform: "matrix(0.36, -0.05, -0.05, 0.36, -763.84, -4024.16)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "71ad8313-6700-4823-b6b7-3bc8329f764a",
    x1: 4017.27,
    y1: 11983.61,
    x2: 4108.05,
    y2: 12074.38,
    xlinkHref: "#03f076b9-d3a4-49a8-a3f2-45d68955c550"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "83a1b9a4-9852-4466-8dd2-ef6e1848b9e6",
    x1: 4153.41,
    y1: 12002.31,
    x2: 4244.18,
    y2: 12093.08,
    xlinkHref: "#03f076b9-d3a4-49a8-a3f2-45d68955c550"
  })), /*#__PURE__*/React.createElement("title", null, "public-sector-hi"), /*#__PURE__*/React.createElement("g", {
    id: "f1241ef6-4eec-4675-a42d-725a539e4bd6",
    "data-name": "public-sector-hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0c547cf5-6c21-456f-96cd-18771a21edfa",
    "data-name": "Cloud_upload_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5db05201-a683-4bfa-aaf8-3cdf7086e851",
    "data-name": "Calls_Contacts_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f9c442fa-7bd4-4abe-8f0a-750b45a0ca84",
    "data-name": "PayG_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "baa07b3d-4a0e-4651-aadc-b1691abae87e",
    "data-name": "Mobile_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "32ec1ab2-9d5f-448d-b56b-3ca88789f78a",
    "data-name": "My_Vodafone_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e03b8d89-0f81-4521-afba-587c14ea1ed3",
    "data-name": "Settings_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a99f4658-eb2a-4cb1-94a9-e154466218d4",
    "data-name": "User_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d546af8f-4eff-4a38-b36a-6f27539c9a09",
    "data-name": "Video_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "aaa136db-c1ab-45ab-98f5-77d19d226bde",
    "data-name": "Tutorials_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e7e5dd18-78c0-4def-9277-0a97e458dd19",
    "data-name": "Community_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "649288d6-9097-4be6-8ae9-c9c2f3b374f0",
    "data-name": "Entertainment_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2128d040-1c5c-4300-b90f-4432cc6007eb",
    "data-name": "Insurance_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "62e882ee-2231-4b59-92f1-2c52a2dec782",
    "data-name": "Photos_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9b2d1370-b3c3-41f0-801f-98a271dccf21",
    "data-name": "Pie_chart_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0fe432de-28a7-4e56-85d0-fde2a1750a75",
    "data-name": "Shopping_trolley_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "308e4d95-bb51-4993-8975-5986ccfbe1cf",
    "data-name": "Business_phone_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5c4fba96-79ff-4dc3-8fbb-8af51542e8d8",
    "data-name": "Bundles_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9434776f-4142-418f-bca9-df339d65daf4",
    "data-name": "Customer_care_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1f422d6b-fa42-4cd6-9b43-562bb6ce2eff",
    "data-name": "Minutes_sms_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "83b1bf33-eada-4186-8fb2-021c7781b938",
    "data-name": "Bar_chart_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a200b7c4-d5e6-4fac-a2a8-0ba8cdbeefe8",
    "data-name": "Line_chart_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "93d5993a-34bc-456b-950a-f377752bd986",
    "data-name": "Blog_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b3a36a35-8f24-456d-8794-c00c15eb5ba8",
    "data-name": "SoHo_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9b8983bc-f1d9-46c0-8209-7886836e907f",
    "data-name": "SME_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fb05b3ab-33f8-4145-ba79-2dd1a65edad3",
    "data-name": "Public_sector_ic_hi"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 59.25,
    y: 88,
    width: 73,
    height: 40,
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.25,
    y: 86.83,
    width: 24,
    height: 42.17,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.25,
    y: 86.83,
    width: 24,
    height: 42.17,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.25,
    y: 86.83,
    width: 24,
    height: 42.17,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.25,
    y: 86.83,
    width: 24,
    height: 42.17,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.25,
    y: 86.83,
    width: 24,
    height: 42.17,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.25,
    y: 86.83,
    width: 24,
    height: 42.17,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.25,
    y: 128,
    width: 144,
    height: 24,
    rx: 4,
    ry: 4,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.25,
    y: 143.92,
    width: 159.93,
    height: 24,
    rx: 4,
    ry: 4,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.25,
    y: 142,
    width: 144,
    height: 2,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.25,
    y: 148,
    width: 160,
    height: 2,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.25,
    y: 154,
    width: 160,
    height: 2,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.25,
    y: 160,
    width: 160,
    height: 2,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.25,84V70.3a4,4,0,0,1,2-3.45L94,23.38a4,4,0,0,1,4.31,0l67.94,43.46a4,4,0,0,1,2,3.46V84a4,4,0,0,1-4,4h-136A4,4,0,0,1,24.25,84Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,86H28a4,4,0,0,1-4-4v2a4,4,0,0,0,4,4H164a4,4,0,0,0,4-4V82A4,4,0,0,1,164,86Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.18,166H20.25a4,4,0,0,1-4-4v2a4,4,0,0,0,4,4H172.18a4,4,0,0,0,4-4v-2A4,4,0,0,1,172.18,166Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.25,68h144a0,0,0,0,1,0,0V84a4,4,0,0,1-4,4h-136a4,4,0,0,1-4-4V68A0,0,0,0,1,24.25,68Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.25 120.28 35.25 96.17 35.25 88 59.25 88 59.25 120.28",
    opacity: 0.2,
    fill: "url(#03f076b9-d3a4-49a8-a3f2-45d68955c550)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.25 120.28 84.25 96.17 84.25 88 108.19 88 108.25 120.28",
    opacity: 0.2,
    fill: "url(#71ad8313-6700-4823-b6b7-3bc8329f764a)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.25 120.28 132.25 96.17 132.25 88 156.19 88 156.25 120.28",
    opacity: 0.2,
    fill: "url(#83a1b9a4-9852-4466-8dd2-ef6e1848b9e6)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }))))))))))))))))))))))))))));
}

var _default = ic_public__sector;
exports.default = _default;